//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  SfHeading,
  SfButton
} from '@storefront-ui/vue';
import { useRouter, computed } from '@nuxtjs/composition-api';
import { onSSR } from '@vue-storefront/core';
import { usePreviewOrderStore } from '~/stores/previewOrder';
import ShippingAddressSelect from '~/components/MyAccount/ShippingAddressSelect';
import { usePreviewOrder } from '@bee-hole/coms';
import { EventBus } from '@/plugins/eventBus';
export default {
  name: 'Billing',
  components: {
    SfHeading,
    SfButton,
    ShippingAddressSelect
  },
  setup(props, context) {
    const router = useRouter();
    const { preorder, error: preOrderErr } = usePreviewOrder();
    const previewOrderStore = usePreviewOrderStore();
    const builingId = computed(() => {
      return String(previewOrderStore?.builing?.addressId || '');
    });
    const handleFormSubmit = async () => {
      if (previewOrderStore.builing) {
        router.push(context.root.localePath({ name: 'payment' }));
      } else {
        // console.error('没有选择收获地址');
      }
    };

    // 选中收货地址
    const selectAddress = (address, pageNo) => {
      if (address) {
        previewOrderStore.setBuiling(address);
        if (pageNo) {
          previewOrderStore.setbillingPageNo(pageNo);
        }
        EventBus.$emit('PreviewOrder', address);
      }
    };

    onSSR(async () => {
    });

    return {
      router,
      previewOrderStore,
      selectAddress,
      handleFormSubmit,
      preorder,
      preOrderErr,
      builingId
    };
  }
};
